import React, { useEffect, useState } from "react";
import VisibilitySensor  from "react-visibility-sensor";

export const textVariants = {
	hidden: {
		opacity: 0.3
	},
	visible: {
		opacity: 1,
		transition : {
			delay: 1,
			duration: 1,
			ease: "easeInOut"
		}
	}
}
export const svgVariants = {
	hidden: { opacity: 0 },
	visible: {
		opacity: 1,
		transition: { duration: 1.5 }
	}
}
export const pathMove = {
	hidden: {
		opacity: 0.3,
		pathLength: 0,
		strokeWidth: 50,
	},
	visible: {
		opacity: 1,
		pathLength: 1,
		strokeWidth: 0,
		transition: {
			delay: 1,
			duration: 2,
			ease: "easeInOut"
		}
	}
}

export const pathRotate = {
	hidden: {
		opacity: 0,
		rotate: 0,
	},
	visible: {
		opacity: 1,
		rotate: 360,

		transition: {
			delay: 1,
			duration: 1,
			repeat: 0,
			ease: "easeInOut",
			times: [0, 0.2, 0.5, 0.8, 1]
		}
	}
}
export const pathDrawDelete = {
	hidden: {
		opacity: 0,
		pathLength: 0,
		strokeWidth: 50,
	},
	visible: {
		opacity: 1,
		pathLength: 1,
		strokeWidth: 0,
		transition: {
			delay: 1,
			duration: 2,
			ease: "easeInOut"
		}
	}
}
export const pathDraw180 = {
	hidden: {
		opacity: 1,
		pathLength: 0,
		strokeWidth: 180,

	},
	visible: {
		opacity: 1,
		pathLength: 1,
		transition: {
			delay: .2,
			duration: 2,
				ease: "easeInOut"
		}
	}
}
export const pathDraw120 = {
	hidden: {
		opacity: 1,
		pathLength: 0,
		strokeWidth: 120,

	},
	visible: {
		opacity: 1,
		pathLength: 1,
		transition: {
			delay: .2,
			duration: 2,
				ease: "easeInOut"
		}
	}
}
export const pathDraw = {
	hidden: {
		opacity: 1,
		pathLength: 0,
		strokeWidth: 50,

	},
	visible: {
		opacity: 1,
		pathLength: 1,
		transition: {
			delay: .2,
			duration: 2,
				ease: "easeInOut"
		}
	}
}
export const pathDraw20 = {
	hidden: {
		opacity: 1,
		pathLength: 0,
		strokeWidth: 20,

	},
	visible: {
		opacity: 1,
		pathLength: 1,
		transition: {
			delay: .2,
			duration: 2,
				ease: "easeInOut"
		}
	}
}
export const staggerChildren = {
		hidden: { opacity: 0,  },
		visible: {
			opacity: 1,
			transition: {
				ease: "easeInOut",
				duration: 2,
				delayChildren: .2,
				staggerChildren: .3,
			},
		},
	};
export const staggerChildrenList = {
	hidden: { opacity: 0,  },
	visible: { opacity: 1,   },
};
function SVGJSContainer({ controls, children }, isVisible) {

	const [ visibility, setVisibility ] = useState(false);

	useEffect(() => {
		if(visibility) {
			controls.start('visible');
		}
		else {
			controls.start('hidden');
		}
	}, [controls, visibility]);

	const handleVisibility = (isVisible) => {
		setVisibility(isVisible)
	}



	return (
		<VisibilitySensor partialVisibility onChange={(isVisible) => {
				handleVisibility(isVisible)
			}}
		>
			{ children }
		</VisibilitySensor>
	)
}
export default SVGJSContainer;
